import React, { useEffect, useState } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { API } from '../../../API/API';

const DisabilityReport = (props) => {

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [columns] = useState([
        {
            name: 'Ажилтны нэр',
            fieldName: 'empfirstname',
            colSize: 'mid'
        },
        {
            name: 'Албан тушаал',
            fieldName: 'positionname',
            colSize: 'mid'
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'departmentname'
        },
        {
            name: 'ХЧА төрөл',
            fieldName: 'illnesstypename',
            minColSize: 'mid'
        },
        {
            name: 'ХЧА заалт',
            fieldName: 'illnessindicationname',
            minColSize: 'mid'
        },
        {
            name: 'ХЧА шалтгаан',
            fieldName: 'reasonname'
        },
        {
            name: 'Өвчний ангилал',
            fieldName: 'illnessname',
            minColSize: 'mid'
        },
        {
            name: 'Групп тогтоосон огноо',
            fieldName: 'invalidbegdate'
        },
        {
            name: 'Үргэлжлэх хугацаа',
            fieldName: 'durationname'
        },
        {
            name: 'Комиссын шийдвэр',
            fieldName: 'desictionname'
        }, {
            name: 'Хүйс',
            fieldName: 'empgendername'
        }
    ]);

    const getData = async () => {
        setLoading(true);
        let tData = [];
        await API.get('/api/humanresource/report/get_emp_invalid_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });
        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title='Хөгжлийн бэрхшээл'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                dataCount={data?.length}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default DisabilityReport;